module.exports = __webpack_public_path__ + "img/no_image_available.4ca5b955.jpg";